import gql from 'graphql-tag';

export const ALL_RUN_GROUPS = gql`
  query AllRunGroups($projectName: String!, $entityName: String!) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(groupKeys: ["group"]) {
        edges {
          node {
            id
            name
            group
          }
        }
      }
    }
  }
`;
